<template>
  <div>
    <br />
    <div class="columns">
      <div class="column is-one-quarter">
        <div class="control is-horizontal">
          <div
            class="control is-grouped has-text-centered"
            style="display: flex"
          >
            <div
              onclick="document.getElementById('avatar').click()"
              class
              style="display: block; margin: auto"
            >
              <div
                style="
                  width: 200px;
                  height: 200px;
                  border-radius: 50%;
                  overflow: hidden;
                  border: 2px solid #ccc;
                "
                v-if="body.profile.avatar"
              >
                <img
                  :src="body.profile.avatar"
                  class="fit-cover"
                  style="height: 100%; width: 100%"
                />
              </div>
              <span v-else>
                <i class="fa fa-user-circle-o" style="font-size: 10em"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="row">
          <div v-if="body.username" class="columns">
            <div class="column is-2">
              <p class="label">Username:</p>
            </div>
            <div class="column is-10">
              <p>{{ body.username }}</p>
            </div>
          </div>

          <div v-if="body.profile.firstname" class="columns">
            <div class="column is-2">
              <p class="label">First Name:</p>
            </div>
            <div class="column is-10">
              <p class="font-weight-bold">{{ body.profile.firstname }}</p>
            </div>
          </div>

          <div v-if="body.profile.lastname" class="columns">
            <div class="column is-2">
              <p class="label">Last Name:</p>
            </div>
            <div class="column is-10">
              <p class="font-weight-bold">{{ body.profile.lastname }}</p>
            </div>
          </div>

          <div v-if="body.profile.phone" class="columns">
            <div class="column is-2">
              <p class="label">Phone:</p>
            </div>
            <div class="column is-10">
              <p class="font-weight-bold">{{ body.profile.phone }}</p>
            </div>
          </div>

          <div v-if="body.profile.gender" class="columns">
            <div class="column is-2">
              <p class="label">Gender:</p>
            </div>
            <div class="column is-10">
              <p class="font-weight-bold">{{ body.profile.gender }}</p>
            </div>
          </div>

          <div v-if="body.profile.postal_code" class="columns">
            <div class="column is-2">
              <p class="label">Postal Code:</p>
            </div>
            <div class="column is-10">
              <p class="font-weight-bold">{{ body.profile.postal_code }}</p>
            </div>
          </div>

          <div v-if="body.profile.city" class="columns">
            <div class="column is-2">
              <p class="label">City:</p>
            </div>
            <div class="column is-10">
              <p class="font-weight-bold">{{ body.profile.city }}</p>
            </div>
          </div>

          <div v-if="body.profile.address" class="columns">
            <div class="column is-2">
              <p class="label">Address:</p>
            </div>
            <div class="column is-10">
              <p class="font-weight-bold">{{ body.profile.address }}</p>
            </div>
          </div>
          <!-- <div class="columns">
            <div class="column is-2">
              <p class="label">Type:</p>
            </div>
            <div class="column is-10">
              <p class="font-weight-bold">{{body.customer_type?body.customer_tyoe:''}}</p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <hr />
    <div class="item-box reset-password">
      <div class="item-title">
        <p class="sub-title">Customer Type</p>
      </div>

      <div class="item-content">
        <div class="select">
          <select v-model="customerType" style="min-width: 140px">
            <!-- <option
              :disabled="true"
              :value="''"
            >Null</option> -->
            <option v-for="c in listCustomerType" :value="c.id" :key="c.id">
              {{ c.name }}
            </option>
          </select>
        </div>
        <button
          class="button is-info"
          :disabled="customerType === '' || !customerType"
          @click="updateType()"
        >
          Save
        </button>
      </div>
    </div>
    <hr />
    <div class="item-box reset-password">
      <div class="item-title">
        <p class="sub-title">Reset password</p>
      </div>

      <div class="item-content">
        <button
          v-if="isUpdate"
          v-show="!isReset"
          class="button is-info"
          @click="showResetPassword"
        >
          Change password
        </button>
        <form v-show="isReset" @submit.prevent="save()">
          <div
            :class="{ 'is-invalid': errors.has('password') }"
            class="form-group"
          >
            <div class="control has-icons-left has-icons-right">
              <input
                v-if="isReset"
                v-validate="'required|min:6|max:255'"
                :class="{ 'is-danger': errors.has('password') }"
                name="password"
                v-model.trim="password"
                class="input"
                :type="passwordType"
              />
              <input
                v-else
                name="password"
                v-model.trim="password"
                class="input"
                :type="passwordType"
              />
              <span v-show="errors.has('password')" class="help is-danger">{{
                errors.first("password")
              }}</span>
            </div>
          </div>
          <div class="has-text-right" style="display: block; margin-top: 10px">
            <button class="button is-info text-r">Save password</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { media, user, customer } from "api";
  import mixin from "components/mixin";
  import config from "configSite";

  export default {
    mixins: [mixin],
    props: {
      data: {
        type: Object,
        default() {
          return {};
        },
        isSaving: Boolean,
        isUpdate: false,
      },
    },
    data() {
      return {
        body: {
          id: this.data.id ? this.data.id : "",
          username: this.data.username ? this.data.username : "",
          profile: {
            firstname:
              this.data.profile && this.data.profile.firstname
                ? this.data.profile.firstname
                : "",
            lastname:
              this.data.profile && this.data.profile.lastname
                ? this.data.profile.lastname
                : "",
            address:
              this.data.profile && this.data.profile.address
                ? this.data.profile.address
                : "",
            city:
              this.data.profile && this.data.profile.city
                ? this.data.profile.city
                : "",
            postal_code:
              this.data.profile && this.data.profile.postal_code
                ? this.data.profile.postal_code
                : "",
            phone:
              this.data.profile && this.data.profile.phone
                ? this.data.profile.phone
                : "",
            gender:
              this.data.profile && this.data.profile.gender
                ? this.data.profile.gender
                : "",
            avatar:
              this.data.profile && this.data.profile.avatar
                ? this.data.profile.avatar
                : "",
          },
        },

        isReset: false,
        password: "",
        listCustomerType: [],
        customerType: this.data.customer_type ? this.data.customer_type : "",
      };
    },
    created() {
      this.perUpdate();
      this.getCustomerType();
    },
    computed: {
      passwordType: function () {
        // return this.isShowPass ? 'text' : 'password';
        return "text";
      },
      iconEyes: function () {
        return this.isShowPass ? "icon-fa-eye-slash" : "icon-fa-eye";
      },
    },

    methods: {
      getCustomerType() {
        customer
          .getType({ is_exceptable: "guest" })
          .then((res) => {
            this.listCustomerType = res.data.data;
          })
          .catch((err) => {
            console.log("err :", err);
          });
      },
      showResetPassword() {
        this.isReset = true;
      },
      hideResetPassword() {
        this.isReset = false;
        this.password = "";
      },
      showHidePass() {
        this.isShowPass = !this.isShowPass;
      },
      onChangeAvatar(file) {
        media
          .uploadMulti([file])
          .then((res) => {
            if (res.data.success) {
              this.body.profile.avatar = res.data.data[0].full_url;
            }
          })
          .catch((err) => {
            let errors = err.response.data.error.message;
            if (err.response.data.error.errors) {
              let arr = [];
              for (let key in err.response.data.error.errors) {
                arr.push(err.response.data.error.errors[key]);
              }
              errors = arr.join();
            }
            this.openNotificationWithType("danger", {
              title: "Failed!",
              message: errors,
            });
          });
      },
      cancel() {
        this.$emit("cancel");
      },
      updateType() {
        let loader = this.$loading.show();

        customer
          .customerUpdateManualType(this.body.id, this.customerType)
          .then((res) => {
            this.openNotificationWithType("success", {
              title: "Success!",
              message: "Update type successfully!",
            });
            loader.hide();
          })
          .catch((error) => {
            this.openNotificationWithType("danger", {
              title: "Error",
              message: "Can not change type!",
            });
            this.isSaving = false;
            loader.hide();
          });
      },
      savePass() {
        this.isSaving = true;
        let loader = this.$loading.show();

        user
          .resetPassword(this.password, this.body.id)
          .then((res) => {
            this.openNotificationWithType("success", {
              title: "Success!",
              message: "Password has been reset successfully!",
            });
            this.isSaving = false;
            this.hideResetPassword();
            loader.hide();
          })
          .catch((error) => {
            this.openNotificationWithType("danger", {
              title: "Error",
              message: "Can not reset password!",
            });
            this.isSaving = false;
            loader.hide();
          });
      },
      save() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.savePass();
          }
        });
      },
      perUpdate() {
        this.isUpdate = this.hasPermission([
          config.permission.CUSTOMERS_UPDATE,
        ]);
      },
    },
    mounted() {
      //   console.log('chay mounted')
      //   console.log(this.hasPermission([config.permission.CUSTOMERS_INDEX]))
    },
  };
</script>

<style scoped>
  .avatar-me:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  p.sub-title {
    color: #363636;
    font-size: 20px;
    font-weight: 600;
    line-height: 50px;
  }
</style>
